import React from 'react';
import styled from '@emotion/styled';
import TextDisplay from 'components/text_display';
import { Theme } from '@seedlang/constants';
import { gaps } from 'components/layout/stack';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${gaps.sm};
  width: 100%;
  font-size: 14px;
  color: ${Theme.darkGray};

  p {
    margin: 0;
  }
`;

function SmallGrammarTip({ grammarTip, showTipIcon }) {
  return (
    <Wrapper>
      {showTipIcon &&
        <i className='fa fa-lightbulb-o' style={{fontSize: '16px', color: Theme.orange }}/>
      }
      <TextDisplay htmlText={grammarTip} />
    </Wrapper>
  );
}

export default SmallGrammarTip;